'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (string) {
  if (typeof string === 'undefined') {
    return '';
  }

  return encodeURIComponent(string);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-sharingbuttons/dist/utils/encodeURI.js
// module id = 525
// module chunks = 0 1 5